<template>
	<div class="add-detail-total">
		<managing-section :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left"></div>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						type="button"
						@click="excelDown"
					>
						엑셀 다운로드
					</button>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th rowspan="2">날짜</th>
						<th rowspan="2">노출</th>
						<th rowspan="2">클릭</th>
						<th rowspan="2">클릭율</th>
						<th colspan="3">AOS</th>
						<th colspan="3">iOS</th>
						<th colspan="3">WEB</th>
						<th colspan="3">미분류</th>
					</tr>
					<tr>
						<th>노출</th>
						<th>클릭</th>
						<th>클릭율</th>
						<th>노출</th>
						<th>클릭</th>
						<th>클릭율</th>
						<th>노출</th>
						<th>클릭</th>
						<th>클릭율</th>
						<th>노출</th>
						<th>클릭</th>
						<th>클릭율</th>
					</tr>
				</thead>
				<tbody v-if="parsedList.length">
					<tr v-for="item in parsedList" :key="item.date">
						<td>{{ item.date }}</td>
						<td>{{ item.displayCount }}</td>
						<td>{{ item.actionCount }}</td>
						<td>{{ item.rate }}</td>
						<td>{{ item.aosDisplayCount }}</td>
						<td>{{ item.aosActionCount }}</td>
						<td>{{ item.aosRate }}</td>
						<td>{{ item.iosDisplayCount }}</td>
						<td>{{ item.iosActionCount }}</td>
						<td>{{ item.iosRate }}</td>
						<td>{{ item.webDisplayCount }}</td>
						<td>{{ item.webActionCount }}</td>
						<td>{{ item.webRate }}</td>
						<td>{{ item.nullDisplayCount }}</td>
						<td>{{ item.nullActionCount }}</td>
						<td>{{ item.nullRate }}</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr>
						<td :colspan="16">리스트가 없습니다.</td>
					</tr>
				</tbody>
			</table>
		</managing-section>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import util from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';

	export default {
		name: 'AdDetailTotal',
		components: { ManagingSection },
		data() {
			return {
				lastApiUrl: '',
				dailyList: [],
				typeList: ['aos', 'ios', 'web', 'null'],
			};
		},
		computed: {
			...mapState({
				id: state => state.modal.params.id,
				title: state => state.modal.contsTitle,
			}),
			parsedList() {
				this.dailyList
					.sort((a, b) => {
						if (a.date < b.date) return 1;
						if (a.date > b.date) return -1;
						return 0;
					})
					.map(item => {
						let displayCount = 0;
						let actionCount = 0;
						this.typeList.forEach(type => {
							if (!item[`${type}DisplayCount`])
								item[`${type}DisplayCount`] = 0;
							if (!item[`${type}ActionCount`])
								item[`${type}ActionCount`] = 0;
							if (!item[`${type}Rate`])
								item[`${type}Rate`] = '0.00%';
							displayCount += item[`${type}DisplayCount`];
							actionCount += item[`${type}ActionCount`];
						});
						item.displayCount = displayCount;
						item.actionCount = actionCount;
						item.rate = `${((actionCount / displayCount).toFixed(4) * 100).toFixed(2)}%`;
						return item;
					});
				return this.dailyList;
			},
		},
		async created() {
			try {
				const { config, data } = await this.$axiosAdmin2.get(
					`/api/ad/daily?adId=${this.id}`
				);

				this.lastApiUrl = config.url;
				const ad = data.ad_list[0];

				const setChannelData = (channelData, targetObj) => {
					const channel = channelData.channel;
					const displayCount = channelData.display_count;
					const actionCount = channelData.action_count;
					targetObj[`${channel}DisplayCount`] = displayCount;
					targetObj[`${channel}ActionCount`] = actionCount;
					targetObj[`${channel}Rate`] =
						displayCount === 0
							? '0.00%'
							: `${((actionCount / displayCount).toFixed(4) * 100).toFixed(2)}%`;
				};
				this.dailyList = ad.daily_counts.reduce((acc, curr) => {
					const currDateIdx = acc.findIndex(
						item => item.date === curr.date
					);
					if (currDateIdx > -1) {
						setChannelData(curr, acc[currDateIdx]);
					} else {
						const obj = {};
						obj.date = curr.date;
						setChannelData(curr, obj);
						acc.push(obj);
					}
					return acc;
				}, []);
			} catch (err) {
				console.error(err);
				alert(
					'일별 집계 정보 데이터를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
				);
			}
		},
		methods: {
			excelDown() {
				const rows = this.parsedList.map(item => [
					item.date,
					item.displayCount,
					item.actionCount,
					item.rate,
					item.aosDisplayCount,
					item.aosActionCount,
					item.aosRate,
					item.iosDisplayCount,
					item.iosActionCount,
					item.iosRate,
					item.webDisplayCount,
					item.webActionCount,
					item.webRate,
					item.nullDisplayCount,
					item.nullActionCount,
					item.nullRate,
				]);
				util.getCsv(
					[rows],
					[this.title],
					[
						[
							'날짜',
							'노출',
							'클릭',
							'클릭율',
							'AOS 노출',
							'AOS 클릭',
							'AOS 클릭율',
							'iOS 노출',
							'iOS 클릭',
							'iOS 클릭율',
							'WEB 노출',
							'WEB 클릭',
							'WEB 클릭율',
							'미분류 노출',
							'미분류 클릭',
							'미분류 클릭율',
						],
					],
					`글로우픽_${this.title}_${new Date().getTime()}`,
					this.lastApiUrl
				);
			},
		},
	};
</script>
